<template>
	<div id="Portability" class="padded">

		<h5>Cámbiate a Clave Verde</h5>
		
		<p>
			Realiza la solicitud de portabilidad aqui, siempre y cuando ya tengas una SIM o eSIM de Clave Verde
			activa, normalmente el proceso se completa el siguiente dia hábil.
		</p>

		<b-form class="row mt-3 justify-content-center limit-width" ref="submitForm" @submit.prevent="onSubmit($event)">

			<b-form-group class="col-md-12 custom-f-group" label="* Tu nombre completo">
				<b-form-input v-model="form.nombre_completo" type="text" required placeholder="" :minlength="5"
					:maxlength="100" />
			</b-form-group>

			<b-form-group class="col-md-6 col-lg-8 custom-f-group" label="* Número a portar (10 dígitos)">
				<b-form-input v-model="form.telefono" type="text" required placeholder="" :minlength="10"
					:maxlength="10" />
			</b-form-group>

			<b-form-group class="col-md-6 col-lg-4 custom-f-group" label="* NIP de Portabilidad">
				<b-form-input v-model="form.portacion_nip" type="text" required placeholder="" :minlength="3"
					:maxlength="6" />
				<p class="f-w-600">
					Para obtener tu NIP de portabilidad llama al 051 <b>desde el número que deseas portar.</b>
				</p>
			</b-form-group>

			<hr>

			<b-form-group class="col-md-12 custom-f-group"
				label="* Número provisional Clave Verde o ICCID (serie de tu SIM o eSIM nuevo)">
				<b-form-input v-model="form.iccid_msisdn" type="text" required placeholder="" :minlength="10"
					:maxlength="20" />
			</b-form-group>

			<div class="col-md-12 text-center mb-4">
				<p class="f-w-600" style="font-size: 1.10rem;">
					Los campos con * son obligatorios.
				</p>

			</div>


			<lock-button :is-processing="isProcessing" class="mb-3" variant="primary" @click="onSubmit($event)">
				Procesar solicitud
			</lock-button>

			<!-- <div class="col-10 text-center">
				<b-button type="submit" class="btn-send btn-s2" v-if="!isProcessing">Enviar</b-button>
				<b-button type="submit" disabled class="btn-send btn-s2" v-else>Procesando...</b-button>
			</div> -->

		</b-form>

	</div>
</template>

<script>
import axios from 'axios'
import { notify, mixedMSG } from '@/utils';

const portabilidadAPI = 'portabilidad/process/web'

export default {
	name: 'Portability',
	data() {
		return {
			isProcessing: false,
			form: {
				distribuidores_id: '1', // [ToUpdate]
				nombre_completo: '',
				telefono: '',
				portacion_nip: '',
				iccid_msisdn: '',
			}
		}
	},
	computed: {
		apiURI() {
			return 'index.php?r=api/' + portabilidadAPI
		}
	},
	methods: {

		async _portabilidadProcess(data2send) {
			this.isProcessing = true
			try {
				let response = await axios.post(this.apiURI, data2send, { withCredentials: false });
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if(response.msg)
					mixedMSG(response.status, response.msg, response.class);
				return response.status
			} catch (e) {
				console.error(e)
				notify(e);
			} finally {
				this.isProcessing = false
			}
		},

		makeToast(variant = null, msg, title) {
			this.$bvToast.toast(msg, {
				title: title,
				variant: variant,
				solid: true,
				toaster: 'b-toaster-top-right',
				appendToast: true
			})
		},

		async onSubmit(event) {
			if (typeof event !== 'undefined' && event !== null)
				event.preventDefault();
			if (!this.isProcessing) {
				let response = await this._portabilidadProcess(this.form)
				if (response){
					this.$router.replace({name: 'portabilityPageSent'});
				}
			} else {
				console.log('API Ocupada');
			}
		},
	}
}
</script>